import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class AetQuizDeleteService extends BaseService {
  constructor() {
    super(constants.DELETE_AET_QUESTION_DATA, 'AetQuizDeleteStatus');
    this.fetchPayload = null;
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);

    // Get tenantId from payload or headers
    const tenantId = payload.tenantId || headers[constants.BERLIN_TENANT_ID_HEADER];

    // Store fetch payload for refetching after successful delete
    this.fetchPayload = {
      bookId: payload.bookId,
      pageId: payload.pageId,
      tenantId
    };

    // Send only pageId, bookId, questionId to delete API
    const deletePayload = {
      pageId: payload.pageId,
      bookId: payload.bookId,
      question_id: payload.questionId
    };

    return this.getClient('aiadminv2').post(`/cm/quiz-aet/delete`, deletePayload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      const notification = {
        open: true,
        type: 'success',
        message: 'AET Question Deleted successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('aetQuizUtility').setDeleteAetQuestionResponse(response.data);

      // Refetch the updated data to show in UI
      if (this.fetchPayload) {
        Framework.getStoreRegistry().getStore('aetQuizUtility').fetchAetQuiz(this.fetchPayload);
      }
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
